import axios from 'axios'

const curse_words = "gago,tangina,tang ina,putang ina,putangina,pakshet,bobo,inutil,kantutan,tite"
const curse_words2 = "puke,salsal,burat,torjakan,pwet,pingering,bwisit,buwisit,tamod,jakol"

async function cleanCommentBody(content) {
  if (!content) {
    return ""
  }

  try {
    let cleanedText = await axios.get(`https://www.purgomalum.com/service/json?text=${content}&add=${curse_words}`);
    cleanedText = await axios.get(`https://www.purgomalum.com/service/json?text=${cleanedText.data.result}&add=${curse_words2}`);
    return cleanedText.data.result
  } catch (err) {
    console.log('err while cleaning comment body: ', err)
    return ""
  }
}

export default cleanCommentBody